// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"a80f5673","55":"0b7d4328","127":"0b7d4328","263":"0b7d4328","598":"a80f5673","991":"0b7d4328"}[chunkId] + ".chunk.css";
};